function trans(key) {
    var translated = SPORTNETXPAGE.TRANSL[key];

    if (!translated) return key;

    return translated;
}

function has_permission(perm) {
	if (!SPORTNETXPAGE.USER_DATA)
		return false;

	return SPORTNETXPAGE.USER_DATA.permissions.includes(perm);
}

function has_role(role, sports_constraints=[], regions_constraints=[]) {
	if (!SPORTNETXPAGE.USER_DATA)
		return false;

	let has_role = false; 

	has_role = SPORTNETXPAGE.USER_DATA.roles_codes.includes(role);

	if (has_role && sports_constraints.length > 0) {
		let user_sports_ids = SPORTNETXPAGE.USER_DATA.sports_constraints.map(sc => sc.id_sport*1); 
		let user_has_constraints = true;

		sports_constraints.forEach(sc => {
			if (!user_sports_ids.includes(sc.id_sport*1))
				user_has_constraints = false;
		});

		has_role = user_has_constraints;
	}

	if (has_role && regions_constraints.length > 0) {
		let user_regions_ids = SPORTNETXPAGE.USER_DATA.regions_constraints.map(rc => rc.id_region*1); 
		let user_has_constraints = true;

		regions_constraints.forEach(rc => {
			if (!user_regions_ids.includes(rc.id_region*1))
				user_has_constraints = false;
		});

		has_role = user_has_constraints;
	}

	return has_role;
}

function get_person_display_name(person, first_name_key=false, last_name_key=false, display_name_key=false) {
	
	first_name_key = first_name_key ? first_name_key : 'first_name';
	last_name_key = last_name_key ? last_name_key : 'last_name';
	display_name_key = display_name_key ? display_name_key : 'display_name';

    let first_name = first_name_key in person ? person[first_name_key] : false; 
    let last_name = last_name_key in person ? person[last_name_key] : false; 
    let display_name = display_name_key in person ? person[display_name_key] : false;

    if (display_name) {
        return display_name;
    }

    if (first_name && last_name) {
        return first_name + ' ' + last_name.charAt(0).toUpperCase() + '.';
    }

    if (first_name) {
        return first_name;
    }

    return '';
}

export {trans, has_permission, has_role, get_person_display_name};